import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getL1SheetProperty,
  getL2SheetProperty,
  updateLevel2Properties,
} from "../../../WorkbookSlice";
import { nanoid } from "@reduxjs/toolkit";
import { RxCross2 } from "react-icons/rx";
import SelectBox from "./FilterConfigCompComponents/SelectBox";

const measureOptionObjects = [
  {
    label: "Sum",
    value: "SUM",
  },

  {
    label: "Max",
    value: "MAX",
  },
  {
    label: "Min",
    value: "MIN",
  },
  {
    label: "Avg",
    value: "AVG",
  },

  {
    label: "Count",
    value: "COUNT",
  },
  {
    label: "Count Distinct",
    value: "DISTINCT",
  },
  {
    label: "No Calculation",
    value: "calculatedField",
  },
];

const getFilteredOptions = (droppedItem) => {
  const { columnType, dataType } = droppedItem;

  const optionsArray = [];
  let defaultOption = {};

  switch (dataType) {
    case "String":
      optionsArray.push(
        { label: "Count", value: "COUNT" },
        { label: "Count Distinct", value: "DISTINCT" }
      );
      defaultOption =
        columnType === "calculatedField"
          ? { label: "No Calculation", value: "calculatedField" }
          : { label: "Count Distinct", value: "DISTINCT" };
      break;

    case "Number":
      optionsArray.push(...measureOptionObjects);
      defaultOption =
        columnType === "calculatedField"
          ? { label: "No Calculation", value: "calculatedField" }
          : { label: "Sum", value: "SUM" };
      break;

    default:
      optionsArray.push(...measureOptionObjects);
      defaultOption =
        columnType === "calculatedField"
          ? { label: "No Calculation", value: "calculatedField" }
          : { label: "Sum", value: "SUM" };
      break;
  }

  console.log(optionsArray);
  return { optionsArray, defaultOption };
};

export default function MetricConfigComp({
  Sheetid,
  parentKey,
  reduxKey,
  droppedItem,
  handleClosePopup,
  handleSavePopupMetric,
  VizchartType,
}) {
  console.log(droppedItem);

  const { optionsArray, defaultOption } = getFilteredOptions(droppedItem);
  const [index, setIndex] = useState();
  const [alreadyExists, setAlreadyExists] = useState(false);
  const [measure, setMeasure] = useState(defaultOption); // Default to the first option
  console.log(measure);

  const nanoId =
    droppedItem.nanoId !== undefined ? droppedItem.nanoId : nanoid();
  const valueArray = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "query", reduxKey)
  );
  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const dispatch = useDispatch();

  const handleConditionalFormattingMeasure = () => {
    if (!customizationObject.conditionalFormatting) return null;

    const itemIndex = customizationObject.conditionalFormatting.findIndex(
      (item) => item.columnNanoId === droppedItem.nanoId
    );
    console.log(itemIndex);

    if (itemIndex !== -1) {
      const updatedConditionalFormatting = [
        ...customizationObject.conditionalFormatting,
      ];

      updatedConditionalFormatting[itemIndex] = {
        ...updatedConditionalFormatting[itemIndex],
        measure: measure,
        rulesArray: updatedConditionalFormatting[itemIndex].rulesArray.map((rItem) => ({
          ...rItem, 
          measure: `${measure.value}_${rItem.columnName}`
        }))
      };
      

      console.log(updatedConditionalFormatting[itemIndex]);
      dispatch(
        updateLevel2Properties({
          reduxKey: "conditionalFormatting",
          Sheetid: Sheetid,
          parentKey: "customization",
          value: updatedConditionalFormatting[itemIndex],
          itemInArray: true,
          index: itemIndex,
        })
      );
    } else {
      console.log("Item not found");
    }
  };

  const valueArrayLength =
    valueArray.length === 1 ? 1 : valueArray.length === 2 ? 2 : 0;

  const MeasureValue = valueArray.map((item) => item?.measure);

  useEffect(() => {
    if (droppedItem && "nanoId" in droppedItem) {
      // This is an edit scenario
      setAlreadyExists(true);

      // Calculate the existing key
      const ObjectIndex = valueArray.findIndex(
        (obj) => obj.nanoId === droppedItem.nanoId
      );
      setIndex(ObjectIndex);

      // Set measure to the existing measure
      const existingMeasure = optionsArray.find(
        (option) => option.value === droppedItem.measure.value
      );
      if (existingMeasure) {
        setMeasure(existingMeasure);
      }
    } else {
      // This is a fresh drop
      setAlreadyExists(false);
      if (droppedItem.dataType === "Number") {
        setMeasure({
          label: "Sum",
          value: "SUM",
        });
      }
    }
  }, [droppedItem, valueArray]);

  useEffect(() => {
    if (MeasureValue.length > 0) {
      const initialMeasure = optionsArray.find(
        (option) => option.value === MeasureValue[0]
      );
      if (initialMeasure) {
        setMeasure(initialMeasure);
      }
    }
  }, [MeasureValue]);

  const handlechangemeasure = (e) => {
    const selected = optionsArray.find(
      (option) => option.value === e.target.value
    );
    setMeasure(selected);
  };
  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleSavePopupMetric(
        {
          ...droppedItem,
          measure,
          nanoId,
          numberObject: droppedItem.numberObject
            ? droppedItem.numberObject
            : {
                decimalPlaces: 2,
                factor: 1,
                prefix: "$",
                sufix: "M",
                mode: "Auto",
              },
          display: valueArrayLength === 0 ? "bar" : "line",
        },
        alreadyExists,
        index
      );
      handleConditionalFormattingMeasure();
    }
  };
  return (
    <div
      className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50"
      onKeyDown={handleKeyDown}
    >
      <div className="bg-white p-4 rounded shadow-lg w-96">
        <button className="flex items-center justify-between text-lg font-medium mb-4 w-full">
          {`${measure.value}(${droppedItem.rename})`}
          <RxCross2
            onClick={() => handleClosePopup(droppedItem)}
            className="text-black"
          />
        </button>
        <div className="mb-4">
          <label
            htmlFor="select2"
            className="block text-sm font-medium text-gray-700"
          >
            Measure
          </label>
          <SelectBox
            value={measure.value}
            onChange={handlechangemeasure}
            optionsArray={optionsArray}
          />
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={() => handleClosePopup(droppedItem)}
            className="px-4 py-2 font-medium border text-black tracking-wide rounded-md"
          >
            Close
          </button>
          <button
            onClick={() => {
              handleSavePopupMetric(
                {
                  ...droppedItem,
                  measure,
                  nanoId,
                  numberObject: droppedItem.numberObject
                    ? droppedItem.numberObject
                    : {
                        decimalPlaces: 2,
                        factor: 1,
                        prefix: "$",
                        sufix: "M",
                        mode: "Auto",
                      },
                  display: valueArrayLength === 0 ? "bar" : "line",
                },
                alreadyExists,
                index
              );
              handleConditionalFormattingMeasure();
            }}
            className="bg-blue-950 text-white px-4 py-2 font-medium tracking-wide rounded-md"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export { measureOptionObjects };
